// src/firebase.js

import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { initializeFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

// Optional: Import getAnalytics if you plan to use it
// import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyC5ef8OT0cwoO0iV-KIfzGfv8y9sXMINVM", // Your actual API key
  authDomain: "truckmemo2.firebaseapp.com",          // Your actual auth domain
  projectId: "truckmemo2",                           // Your actual project ID
  storageBucket: "truckmemo2.firebasestorage.app",   // <<< CORRECTED BUCKET NAME
  messagingSenderId: "470314939716",                 // Your actual sender ID
  appId: "1:470314939716:web:8d1abd810855b2c3db1311", // Your actual app ID
  measurementId: "G-GL3F969EZL"                      // Your actual measurement ID (if you use Analytics)
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
const auth = getAuth(app);
// Firestore, with a fallback transport.
//
// By default the web SDK talks to Firestore over WebChannel, a long-lived
// streaming connection. Plenty of networks break it: corporate proxies, some
// antivirus and VPN products, and ISPs that interfere with long-held HTTP
// connections. When that happens the symptom is confusing, because ordinary
// HTTPS keeps working — a Cloud Function call goes through fine while a Firestore
// write from the same page fails with the unhelpful code "internal".
//
// That is exactly what was happening to users in Georgia in October 2026: invoice
// emails sent successfully (a plain callable), then marking the load as invoiced
// failed, the UI reported the whole thing as a failed send, and dispatchers
// re-sent — one broker received 86 duplicate invoices. Users in the US never saw
// it, because their route to Google never broke the stream.
//
// autoDetectLongPolling tries WebChannel first and falls back to long polling
// when the connection does not come up. Where WebChannel works it costs nothing;
// where it does not, it is the difference between the app working and not.
const db = initializeFirestore(app, {
  experimentalAutoDetectLongPolling: true,
});
const storage = getStorage(app);
const functions = getFunctions(app);

// Optional: Initialize Analytics
// const analytics = getAnalytics(app);

// Export the services you want to use in other parts of your app
export { auth, db, storage, functions, app };